import { Route, Routes } from 'react-router-dom'
import DataViewList from './List'
import DefaultAttributeSetView from './Details/Views'

export interface IDataViewProps {
  dvBasePath: string
}

const DataView = () => {
  // REVIEW: see if there is better way to retrieve path from React Router v6
  const path = '/data-management/data-view'

  return (
    <Routes>
      <Route
        path='details/views/:attributeSetId'
        element={<DefaultAttributeSetView dvBasePath={path} />}
      />
      <Route path='*' element={<DataViewList dvBasePath={path} />} />
    </Routes>
  )
}

export default DataView
